import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class ObjectSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'object-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
